/**
 * Hero Download Component JavaScript
 *
 * Funkce:
 * - Tag navigation (kotvy na sekce)
 * - Show more functionality (zobrazení skrytých souborů)
 */

document.addEventListener("DOMContentLoaded", function () {
    const heroDownloadSections = document.querySelectorAll(".hero-download");

    heroDownloadSections.forEach((section) => {
        initHeroDownload(section);
    });
});

function initHeroDownload(heroSection) {
    const tags = heroSection.querySelectorAll(".tags__content-tag[data-target]");
    const showMoreBtns = heroSection.querySelectorAll(".show-more-btn");

    // Funkčnost tagů pro navigaci
    initTagNavigation(tags);

    // Funkčnost tlačítek "Zobrazit více"
    initShowMoreButtons(showMoreBtns);
}

function initTagNavigation(tags) {
    tags.forEach((tag) => {
        tag.addEventListener("click", function (e) {
            e.preventDefault();
            const targetId = this.getAttribute("data-target");

            // Odstranit active třídu ze všech tagů
            tags.forEach((t) => t.classList.remove("active"));
            // Přidat active třídu k aktuálnímu tagu
            this.classList.add("active");

            // Najít cílovou sekci a navigovat k ní
            const targetSection = document.getElementById(targetId);
            if (targetSection) {
                const headerHeight = document.querySelector(".site-header")?.offsetHeight || 0;
                const offset = targetSection.offsetTop - headerHeight - 20;

                window.scrollTo({
                    top: offset,
                    behavior: "smooth",
                });
            }
        });
    });
}

function initShowMoreButtons(showMoreBtns) {
    showMoreBtns.forEach((btn) => {
        btn.addEventListener("click", function () {
            const downloadSection = this.closest(".download-files");
            const hiddenFiles = downloadSection.querySelectorAll(".hidden-file");

            // Zobrazit skryté soubory s animací
            hiddenFiles.forEach((file, index) => {
                setTimeout(() => {
                    file.style.display = "flex";
                    file.style.opacity = "0";
                    file.style.transform = "translateY(20px)";

                    // Animace
                    requestAnimationFrame(() => {
                        file.style.transition = "opacity 0.3s ease, transform 0.3s ease";
                        file.style.opacity = "1";
                        file.style.transform = "translateY(0)";
                    });
                }, index * 100); // Postupné zobrazení
            });

            // Skrýt tlačítko s animací
            this.style.transition = "opacity 0.3s ease, transform 0.3s ease";
            this.style.opacity = "0";
            this.style.transform = "scale(0.95)";

            setTimeout(() => {
                this.style.display = "none";
            }, 300);
        });
    });
}

// Export pro možné použití v jiných skriptech
window.HeroDownload = {
    init: initHeroDownload,
    initTagNavigation: initTagNavigation,
    initShowMoreButtons: initShowMoreButtons,
};
